export default __webpack_public_path__ + "tktypebold.ttf";